import { useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { GetBudgetListData, SetBudgetListData } from '../../store/budgetAtom';
import { budgetService } from '../../services/budgetService';
import { formatCustomNumber } from '../../helpers/formatCustomNumber';
import { normalizeBudgetListPayload } from './budgetDataHelpers';

function BudgetScroll({ viewItemDetails }) {
  const storedBudgetListData = GetBudgetListData();
  const budgetListPayload = Array.isArray(storedBudgetListData)
    ? { budget_info: storedBudgetListData, financial_year: [], budget_term: [] }
    : storedBudgetListData;
  const budgetList = budgetListPayload?.budget_info || [];
  const setBudgetListData = SetBudgetListData();
  const { id } = useParams();

  const getBudgetListFromApi = useCallback(async () => {
    try {
      const response = await budgetService.budgetList();
      setBudgetListData(normalizeBudgetListPayload(response?.data));
    } catch (err) {
      console.error(err);
    }
  }, [setBudgetListData]);

  useEffect(() => {
    if (!budgetList.length) {
      getBudgetListFromApi();
    }
  }, [budgetList.length, getBudgetListFromApi]);

  return (
    <section className="mt-4 rounded-lg border border-gray-200 bg-white shadow-sm">
      <div className="border-b border-gray-200 px-3 py-2 text-xs font-semibold uppercase tracking-wider text-gray-400">Budgets</div>

      {budgetList.length ? (
        budgetList.map((info, index) => (
          <div
            key={info?.budget_ref_no ?? index}
            onClick={() => viewItemDetails(info?.budget_ref_no)}
            className={
              'flex cursor-pointer items-center border-b border-gray-200 p-3 transition-colors duration-200 hover:bg-gray-50 ' +
              (Number(id) === info?.budget_ref_no ? 'bg-blue-50' : '')
            }
          >
            <div className="flex-1">
              <div className="text-sm font-semibold text-gray-800">{info?.budget_name}</div>
              <div className="text-sm italic text-gray-500">FY {info?.financial_year_name || info?.financial_year_code || '-'}</div>
              <div className="text-sm text-gray-600">{formatCustomNumber(info?.amout ?? 0)}</div>
            </div>
          </div>
        ))
      ) : (
        <div className="p-4 text-sm text-gray-500">No budgets found.</div>
      )}
    </section>
  );
}

export default BudgetScroll;
